(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('SegmentFieldOptionController', SegmentFieldOptionController);

    SegmentFieldOptionController.$inject = ['$state', 'SegmentFieldOption', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function SegmentFieldOptionController($state, SegmentFieldOption, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = {
            label: pagingParams.label,
            segmentFieldId: pagingParams.segmentFieldId,
            value: pagingParams.value
        };
        if (!pagingParams.firstRun) {
            loadAll();
        }

        function loadAll () {
            SegmentFieldOption.query({
                label: pagingParams.label,
                segmentFieldId: pagingParams.segmentFieldId,
                value: pagingParams.value,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.segmentFieldOptions = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                label: vm.searchQuery.label,
                segmentFieldId: vm.searchQuery.segmentFieldId,
                value: vm.searchQuery.value,
                firstRun: false
            });
        }
        function search(searchQuery) {
            vm.links = null;
            vm.page = 1;
            vm.predicate = pagingParams.predicate;
            vm.reverse = pagingParams.ascending;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = pagingParams.predicate;
            vm.reverse = pagingParams.ascending;
            vm.searchQuery = {
                label: null,
                segmentFieldId: null,
                value: null
            };
            vm.transition();
        }
    }
})();
